// src/app/redux/sagas/candidatsSaga.js
import { call, put, takeLatest, all } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_CANDIDATS_REQUEST,
    fetchCandidatsSuccess,
    fetchCandidatsFail,

    CREATE_CANDIDAT_REQUEST,
    createCandidatSuccess,
    createCandidatFail,

    UPDATE_CANDIDAT_REQUEST,
    updateCandidatSuccess,
    updateCandidatFail,

    DELETE_CANDIDAT_REQUEST,
    deleteCandidatSuccess,
    deleteCandidatFail,

    setCandidatsLoading,
} from "../actions/candidatsActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

// ===== Fetch =====
export function* fetchCandidatsSaga() {
    const url = `${API_BASE_URL}/api/candidat-theque`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidatsLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCandidatsSuccess(resp.data));
    } catch (e) {
        yield put(fetchCandidatsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCandidatsLoading(false));
    }
}

// ===== Create =====
export function* createCandidatSaga(action) {
    const url = `${API_BASE_URL}/api/candidat-theque`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidatsLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: action.payload, // FormData
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(createCandidatSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidat ajouté",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout candidat";
        yield put(createCandidatFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCandidatsLoading(false));
    }
}

// ===== Update =====
export function* updateCandidatSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/candidat-theque/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidatsLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: payload, // FormData
            uid,
            token,
            headers: { "Content-Type": "multipart/form-data" },
        });

        yield put(updateCandidatSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidat modifié",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: FETCH_CANDIDATS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification candidat";
        yield put(updateCandidatFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCandidatsLoading(false));
    }
}

// ===== Delete =====
export function* deleteCandidatSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/candidat-theque/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCandidatsLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteCandidatSuccess(id));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidat supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression candidat";
        yield put(deleteCandidatFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setCandidatsLoading(false));
    }
}

// ===== Watcher =====
export function* candidatsWatcher() {
    yield all([
        takeLatest(FETCH_CANDIDATS_REQUEST, fetchCandidatsSaga),
        takeLatest(CREATE_CANDIDAT_REQUEST, createCandidatSaga),
        takeLatest(UPDATE_CANDIDAT_REQUEST, updateCandidatSaga),
        takeLatest(DELETE_CANDIDAT_REQUEST, deleteCandidatSaga),
    ]);
}
